import * as React from 'react';
import { IBreadcrumb } from '../../../../types/project/breadcrumbs';
import * as styles from './Breadcrumb.css';

export const Breadcrumb: React.FC<IBreadcrumb> = ({ url, title }) => {
  return (
    <div className={styles['link-container']}>
      <a href={url} className={styles['link']}>
        {title}
      </a>
    </div>
  );
};
